import * as React from 'react';
import { PageState, PageStatus } from 'app/shared/pageSystem/state';
import { lookupRoute } from 'app/shared/pageSystem/routing';

function getRoot(state:any) : PageState {
    return state.currentPage;
}

export function getPageStatus(state:any) : PageStatus {
    return getRoot(state).status;
}

export function getCurrentPage(state: any) : React.ComponentType<any> {
    const root = getRoot(state);
    switch(root.status) {
        case PageStatus.Found:
            const pageName = root.name;
            const route = lookupRoute(pageName);
            if (!route)
                throw new Error('There is no current page');
            return route.page;
        default:
            throw new Error('There is no current page');
    }
}